import {Params} from '@feathersjs/feathers'

import {Color} from '../../types'

import * as feathersService from '../feathers'

export const RESOURCE = 'color'

export const get = async (params?: Params) => feathersService.find<Color>(RESOURCE, params)
